import { render, staticRenderFns } from "./DialogMsg.vue?vue&type=template&id=7059ef9c"
import script from "./DialogMsg.vue?vue&type=script&lang=js"
export * from "./DialogMsg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports